import React from 'react'
import {Image as ReactImage} from 'react-bootstrap'

export const Image = ({imageUrl, alt, fullWidth = false, rounded = false, thumbnail = false}) => {
    return (<ReactImage src={imageUrl} alt={alt} fluid={fullWidth} rounded={rounded} thumbnail={thumbnail} loading="lazy"/>)
}

export default Image